"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _context3 = _interopRequireDefault(require("../Theme/context"));
var _Menu = require("../Menu");
var _index = _interopRequireDefault(require("./index"));
var _SelectBase = _interopRequireDefault(require("./SelectBase"));
var _excluded = ["className", "endIcon", "OpenedStateIcon", "ClosedStateIcon", "InputProps"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (p, ref) {
  var _InputProps$MenuCompo;
  var className = p.className,
    endIcon = p.endIcon,
    OpenedStateIcon = p.OpenedStateIcon,
    ClosedStateIcon = p.ClosedStateIcon,
    InputProps = p.InputProps,
    props = (0, _objectWithoutProperties2["default"])(p, _excluded);
  var state = (0, _react.useRef)({
    open: false
  }).current;
  var changeIconOpenState;
  var _useContext = (0, _react.useContext)(_context3["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona;
  return /*#__PURE__*/_react["default"].createElement(_index["default"], Object.assign({}, props, {
    className: (0, _clsx["default"])((props.classNames || additionalStyles.input || defaultStyle).select, className),
    ref: ref,
    InputComponent: _SelectBase["default"],
    endIcon: endIcon || /*#__PURE__*/_react["default"].createElement(_Menu.DefaultEndIcon, {
      open: state.open,
      OpenedStateIcon: OpenedStateIcon,
      ClosedStateIcon: ClosedStateIcon,
      effect: function effect(p) {
        var actions = p.actions;
        changeIconOpenState = actions.setOpen;
      }
    }),
    InputProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, InputProps ? InputProps : {}), {}, {
      MenuComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, InputProps.MenuComponentProps ? InputProps.MenuComponentProps : {}), {}, {
        PopoverProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, InputProps !== null && InputProps !== void 0 && (_InputProps$MenuCompo = InputProps.MenuComponentProps) !== null && _InputProps$MenuCompo !== void 0 && _InputProps$MenuCompo.PopoverProps ? InputProps.MenuComponentProps.PopoverProps : {}), {}, {
          onOpen: function () {
            var _onOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
              var _InputProps$MenuCompo2, _InputProps$MenuCompo3;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!changeIconOpenState) {
                      _context.next = 3;
                      break;
                    }
                    _context.next = 3;
                    return changeIconOpenState(true);
                  case 3:
                    if (!(InputProps !== null && InputProps !== void 0 && (_InputProps$MenuCompo2 = InputProps.MenuComponentProps) !== null && _InputProps$MenuCompo2 !== void 0 && (_InputProps$MenuCompo3 = _InputProps$MenuCompo2.PopoverProps) !== null && _InputProps$MenuCompo3 !== void 0 && _InputProps$MenuCompo3.onOpen)) {
                      _context.next = 6;
                      break;
                    }
                    _context.next = 6;
                    return InputProps.MenuComponentProps.PopoverProps.onOpen();
                  case 6:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            function onOpen() {
              return _onOpen.apply(this, arguments);
            }
            return onOpen;
          }(),
          onClose: function () {
            var _onClose = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
              var _InputProps$MenuCompo4, _InputProps$MenuCompo5;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!changeIconOpenState) {
                      _context2.next = 3;
                      break;
                    }
                    _context2.next = 3;
                    return changeIconOpenState(false);
                  case 3:
                    if (!(InputProps !== null && InputProps !== void 0 && (_InputProps$MenuCompo4 = InputProps.MenuComponentProps) !== null && _InputProps$MenuCompo4 !== void 0 && (_InputProps$MenuCompo5 = _InputProps$MenuCompo4.PopoverProps) !== null && _InputProps$MenuCompo5 !== void 0 && _InputProps$MenuCompo5.onClose)) {
                      _context2.next = 6;
                      break;
                    }
                    _context2.next = 6;
                    return InputProps.MenuComponentProps.PopoverProps.onClose();
                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            function onClose() {
              return _onClose.apply(this, arguments);
            }
            return onClose;
          }()
        })
      })
    })
  }));
});